import { render, staticRenderFns } from "./GrantMobile.vue?vue&type=template&id=5fc7ff9a&scoped=true&"
import script from "./GrantMobile.vue?vue&type=script&lang=js&"
export * from "./GrantMobile.vue?vue&type=script&lang=js&"
import style0 from "./GrantMobile.vue?vue&type=style&index=0&id=5fc7ff9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc7ff9a",
  null
  
)

export default component.exports